import { render } from "./AiCollapsibleBlock.vue?vue&type=template&id=7f94c0d1&scoped=true"
import script from "./AiCollapsibleBlock.vue?vue&type=script&lang=js"
export * from "./AiCollapsibleBlock.vue?vue&type=script&lang=js"

import "./AiCollapsibleBlock.vue?vue&type=style&index=0&id=7f94c0d1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f94c0d1"]])

export default __exports__